import MarketActivityView from "./component";

export default MarketActivityView;
